import * as Blockly from "blockly";
import BlocklyJs from "blockly/javascript";

export const InitEventBlock = (
  type: string,
  components: string[][],
  defaultComponent?: string | undefined,
) => {
  function showEditor(e) {
    e.stopPropagation();
    e.preventDefault();
    Blockly.dialog.component(
      { x: e.x, y: e.y },
      this.getValue(),
      components.length === 0 ? [["パーツ", ""]] : components,
      (value: string) => {
        if (value !== null) {
          this.setValue(value);
        }
      },
    );
  }

  Blockly.Blocks[`${type}_click_event`] = {
    init: function () {
      const componentsField = new Blockly.FieldDropdown(
        components.length === 0 ? [["パーツ", ""]] : components,
      );
      componentsField.showEditor = showEditor;
      if (defaultComponent) {
        componentsField.setValue(defaultComponent);
      }
      this.appendDummyInput()
        .appendField(componentsField, "component_id")
        .appendField("%{BKY_EVENT_CLICK}");
      this.appendStatementInput("DO");
      this.setStyle("text_blocks");
    },
  };

  BlocklyJs[`${type}_click_event`] = function (block: Blockly.BlockSvg) {
    const logic = BlocklyJs.statementToCode(block, "DO");
    const code = `${logic}\n`;
    return code;
  };
};
